import { render, staticRenderFns } from "./Faskes.vue?vue&type=template&id=4d2d95b2"
import script from "./Faskes.vue?vue&type=script&lang=js"
export * from "./Faskes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports